// material-ui
import logo from 'assets/images/logo.svg';
import { useSelector } from 'react-redux';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
  const siteInfo = useSelector((state) => state.siteInfo);
  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      <img
        src="https://openai-global.com/static/media/img/logo.svg"
        alt={siteInfo.system_name}
        style={{ maxHeight: '100%', margin: 'auto 0' }}
        width="120"
      />
    </div>
  );
};




export default Logo;

